import { render } from "./HallofFame.vue?vue&type=template&id=8c4d5b56&scoped=true"
import script from "./HallofFame.vue?vue&type=script&lang=js"
export * from "./HallofFame.vue?vue&type=script&lang=js"

import "./HallofFame.vue?vue&type=style&index=0&id=8c4d5b56&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c4d5b56"]])

export default __exports__